<template>

  <div id="top" class="private-registry-page">
    <div class="private-registry-intro">
      <UiPageHeader title="Private Clients" description="Search, open, and manage private client accounts from one focused register.">
        <template #actions>
          <router-link :to="{ name: 'privateAdd' }" class="private-registry-add">
            <i class="material-icons" aria-hidden="true">add</i><span>Add client</span>
          </router-link>
        </template>
      </UiPageHeader>
    </div>
  
  <!-- Loader -->
  <div class="container progress" v-if="isLoading && isReady">
    <div class="indeterminate"></div>
  </div>

  <!-- <br /> -->
<!-- 
  <div class="container grey lighten-4 hide-on-small-only">
    <nav class="z-depth-0 grey lighten-4">
     <div class="nav-wrapper">
      <form>
        <div class="input-field">
          <input id="search" type="search" v-model="searchItem" placeholder="Search Clients by Name">
          <label class="label-icon" for="search"><i class="material-icons black-text">search</i></label>
          <i class="material-icons white-text orange" @click="handleClearSearch" v-if="searchItem">clear</i>
        </div>
      </form>
    </div>
    </nav>
  </div> -->

  <!-- <nav class="nav-extended top-card-light">
    <div class="nav-wrapper top-card container">
      <form>
        <div class="input-field">
          <input id="search" type="search" v-model="searchItem" placeholder="Search Clients by Name">
          <label class="label-icon" for="search"><i class="material-icons">search</i></label>
          <i class="material-icons white-text orange" @click="handleClearSearch" v-if="searchItem">clear</i>
        </div>
      </form>
    </div>
  </nav> -->

  <!-- search layer -->
  <!-- <div class="grey lighten-4">
    <div class="container section"></div>
  </div> -->

  <!-- View Marker -->
  <div id="view"></div>


  <div class="private-registry-body">
  <div class="private-registry-content">

    <!-- <div class="card-content">
      <div class="row">
        <div class="col s4">
          <h3 class="header">
            <router-link :to="{ name: 'private' }" class="blue-grey-text text-darken-2">HMO</router-link>
          </h3>
        </div>
        <div class="col s8">
          <span v-for="tab in tabs" :key="tab.id" class="right" :class="{
            'tab-custom-active': tab.id == currTab.id,
            'tab-custom': tab.id != currTab.id,
          }" @click="handleActive(tab)">
            <span v-if="tab.icon"><i class="tiny material-icons cyan-text">{{ tab.icon }}</i></span> 
            {{ tab.title }}
            <span v-if="tab.id == currTab.id"><i class="tiny material-icons blue-grey-text text-darken-2">check_circle</i></span>
          </span>

        </div>
      </div>

    </div> -->

    <!-- Clients -->
    <LoadingDiv v-if="!isReady" />

    <div v-else>
      <!-- <div class="section black-text center">
        <br />
        <h5 v-if="searchItem">
          <span class="black blue-text chip">Search <i class="tiny material-icons">check_circle</i></span>
          <span class="yellow lighten-2 black-text chip"><em>{{ searchItem }}</em></span>
        </h5>
        <h5 v-else>
          <span class="black blue-text chip">Display <i class="tiny material-icons">check_circle</i></span>
          <span class="yellow lighten-2 black-text chip"><em>All Private Clients</em></span>
        </h5>
      </div> -->

      <!-- <div class="section">
        <div class="card" v-for="(client, x) in clients" :key="client.id">
          <div class="card-content">
          <div class="row">
            <div class="col s1">
              <p class="chip grey white-text">{{ numberBadge(x) }}</p>
            </div>

            <div class="col s9">
              <h5>
                <router-link class="private-client-name" :to="{ name: 'privateView', params: { id: client.id } }">{{ client.name }}</router-link>
              </h5>
              <p>{{ client.phone }}, {{ client?.email }}</p>
            </div>

            <div class="col s2">
              <br />
              <span class="new badge" data-badge-caption="principals">{{
              `${client.principals_count
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                }}</span></div>
          </div>
          </div>
        </div>
      </div> -->

   
      <div class="section private-client-surface sba-slide-in">
        <div class="private-registry-toolbar">
          <div class="private-registry-summary" aria-live="polite">
            <strong>{{ clients.length }} {{ clients.length === 1 ? 'client' : 'clients' }} in this view</strong>
            <span>Private client account register</span>
          </div>
          <form class="private-registry-search" @submit.prevent role="search">
            <label class="private-registry-search-label" for="search">Search clients</label>
            <div class="private-registry-search-field">
              <i class="material-icons" aria-hidden="true">search</i>
              <input id="search" type="search" v-model="searchItem" placeholder="Search clients by name" autocomplete="off">
              <button type="button" @click="handleClearSearch" v-if="searchItem" aria-label="Clear client search"><i class="material-icons" aria-hidden="true">close</i></button>
            </div>
          </form>
        </div>

        <div class="private-search-status" v-if="searchItem">
          <div>
            <span>Search active</span>
            <strong>{{ searchItem }}</strong>
          </div>
          <button type="button" @click="handleClearSearch" title="clear search">
            <i class="material-icons">close</i>
          </button>
        </div>
        
        <div class="private-client-list" v-if="clients.length">
          <router-link
            class="private-client-row"
            :class="{
              'is-inactive': client.status === 's',
              'is-pending': client.status !== 'a' && client.status !== 's',
            }"
            :to="{ name: 'privateView', params: { id: client.id } }"
            v-for="(client, index) in clients"
            :key="client.id"
          >
            <span class="private-row-number">{{ numberBadge(index) }}</span>
            <div class="private-client-main">
              <h6 class="private-client-name">{{ client.name }}</h6>
              <p>
                <span>{{ client.phone || "No phone recorded" }}</span>
                <span class="private-contact-dot"></span>
                <span>{{ client?.email || "No email recorded" }}</span>
              </p>
            </div>
            <div class="private-client-state">
              <span class="private-status-chip is-active" v-if="client.status === 'a'">
                {{
                  `${client.principals_count
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                }}
                principals
              </span>
              <span class="private-status-chip is-inactive" v-else-if="client.status === 's'">Inactive client</span>
              <span class="private-status-chip is-pending" v-else>Pending approval</span>
            </div>
            <span class="private-row-open">
              <i class="material-icons">arrow_forward</i>
            </span>
          </router-link>
        </div>
      </div>

      <div class="private-empty-state center" v-if="!clients.length">
        <h6>No private clients found</h6>
        <p>There are no private client records matching this view.</p>
      </div>

      <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
    </div>
  </div>
  </div>
  </div>
</template>


<script>
import { onMounted, ref, computed, watchEffect } from "vue";
import useModuleNavigation from "@/composables/useModuleNavigation";
import getItems from "@/composables/getItems";
import UiPageHeader from "@/ui/components/UiPageHeader.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";

export default {
  name: "privateClientHome",
  components: { UiPageHeader, LoadingDiv, PaginationDiv },
  setup() {
    const home = ref(null);
    const cat = ref("hmo");
    const response = ref(null);
    const isReady = ref(false);
    const isLoading = ref(true);
    const error = ref(null);
    const currUrl = ref(null);
    const currHook = ref(null);
    const searchItem = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);

    // vue router
    const { routeToTab } = useModuleNavigation();

    // start
    onMounted(() => {
      // page name
      document.title = "All (Private) Clients";
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Clients", title: "All", icon: null, url: "private", hash: null, });
      tabs.value.push({ id: 2, name: "Clients", title: "View", icon: "visibility", url: "private", hash: "#view" });
      tabs.value.push({ id: 3, name: "Clients", title: "Add Client", icon: "add_circle", url: "privateAdd", hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.id === 1);
      // set home
      home.value = tabs.value.find(x => x.id === 1);
    });

    // handle curr status
    const handleActive = (tab) => {
      routeToTab(tab, { replace: tab?.url === "private" });
    };

    const scrollToPageTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // numbering
    const numberBadge = (num) => {
      return (
        (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
      );
    };

    // get function
    const getSearchItemsFromApi = (table) => {
      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // starter
    onMounted(() => {
      // set current Url
      currUrl.value = `client/list/search?c=${cat.value}`;
      // set current Hook
      currHook.value = "&";
      // get searchItem items from function
      getSearchItemsFromApi(currUrl.value);
    });

    // restart
    const handleClearSearch = () => {
      // start laoding
      isLoading.value = true;
      // null search
      searchItem.value = null;
      // set current Url
      currUrl.value = `client/list/search?c=${cat.value}`;
      // set current Hook
      currHook.value = "&";
      // get searchItem items from function
      getSearchItemsFromApi(currUrl.value);
    };

    // switch page
    const handlePage = (page) => {
      // start laoding
      isReady.value = false;
      // go back to the top of the page
      scrollToPageTop();
      // get new page items from function
      getSearchItemsFromApi(`${currUrl.value}${currHook.value}page=${page}`); //
    };

    // search watcher
    watchEffect(() => {
      if (searchItem.value) {
        // start laoding
        isLoading.value = true;
        // set current Url
        currUrl.value = `client/list/search?c=${cat.value}&q=${searchItem.value}`;
        // set current Hook
        currHook.value = "&";
        // get searchItem items from function
        getSearchItemsFromApi(currUrl.value);
      } else {
        handleClearSearch();
      }
    });

    // output results
    const clients = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data;
      }
    });

    // output pages
    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value; // get all
      }
    });

    return {
      home,
      handleActive,
      currTab,
      tabs,
      cat,
      handleClearSearch,
      handlePage,
      numberBadge,
      isReady,
      isLoading,
      error,
      searchItem,
      clients,
      allPages,
    };
  },
};
</script>

<style scoped>
.private-client-name { text-transform: uppercase; }
.private-registry-page {
  box-sizing: border-box;
  margin: 0 auto;
  max-width: var(--ui-content-width);
  padding: 2rem 2rem 3rem;
  width: 100%;
}

.private-registry-intro {
  border-bottom: 1px solid var(--ui-border);
  margin-bottom: 2rem;
  padding-bottom: 1.75rem;
}

.private-registry-intro :deep(.ui-page-header) { margin-bottom: 0; }
.private-registry-intro :deep(.ui-page-header__title) { font-size: clamp(1.75rem, 2.1vw, 2rem); }
.private-registry-intro :deep(.ui-page-header__description) { font-size: 1rem; line-height: 1.55; }

.private-registry-add {
  align-items: center;
  background: var(--ui-primary);
  border: 1px solid var(--ui-primary);
  border-radius: calc(var(--ui-radius) - 2px);
  color: var(--ui-primary-foreground);
  display: inline-flex;
  font-size: .8125rem;
  font-weight: 600;
  gap: .5rem;
  min-height: 2.5rem;
  padding: 0 .9rem;
  text-decoration: none;
}
.private-registry-add i { font-size: 1rem; }
.private-registry-toolbar { align-items: center; border-bottom: 1px solid var(--ui-border); display: flex; gap: 1.5rem; justify-content: space-between; padding-bottom: 1.25rem; }
.private-registry-summary { display: flex; flex-direction: column; gap: .15rem; }
.private-registry-summary strong { color: var(--ui-foreground); font-size: 1rem; font-weight: 650; }
.private-registry-summary > span { color: var(--ui-muted-foreground); font-size: .8125rem; }
.private-registry-search { width: min(100%, 24rem); }
.private-registry-search-label { display: block; font-size: .75rem; margin-bottom: .4rem; }
.private-registry-search-field { align-items: center; display: flex; position: relative; }
.private-registry-search-field > i { color: var(--ui-muted-foreground); font-size: 1.1rem; left: .75rem; position: absolute; }
.private-registry-search-field input { box-sizing: border-box; padding-left: 2.25rem !important; padding-right: 2.5rem !important; }
.private-registry-search-field button { align-items: center; background: transparent; border: 0; color: var(--ui-muted-foreground); cursor: pointer; display: flex; padding: .35rem; position: absolute; right: .5rem; }
.private-registry-search-field button i { font-size: 1rem; }
.private-registry-page :is(a, button):focus-visible { outline: 2px solid var(--ui-ring); outline-offset: 2px; }

@layer components {
  .private-registry-page .private-client-row:last-child {
    border-bottom: 1px solid var(--ui-border) !important;
  }
  .private-registry-page .private-client-surface { margin: 0 !important; padding: 0 !important; }
  .private-registry-page .private-client-list { border: 0 !important; border-radius: 0 !important; box-shadow: none !important; margin: 0 !important; }
  .private-registry-page .private-client-row { background: transparent !important; border-radius: 0 !important; border-bottom: 1px solid var(--ui-border) !important; box-shadow: none !important; color: var(--ui-foreground) !important; gap: 1.25rem !important; grid-template-columns: 2.5rem minmax(0, 1fr) minmax(10rem, auto) 2.5rem !important; margin: 0 !important; min-height: 5rem !important; padding: 1.15rem .75rem !important; text-decoration: none !important; transform: none !important; }
  .private-registry-page .private-client-row:is(:hover, :focus-visible) { background: color-mix(in srgb, var(--ui-muted) 45%, transparent) !important; }
  .private-registry-page .private-row-number { background: transparent !important; border: 0 !important; font-size: .8125rem !important; font-weight: 500 !important; height: auto !important; justify-content: flex-start !important; width: auto !important; }
  .private-registry-page .private-client-main h6 { color: var(--ui-foreground) !important; font-size: .875rem !important; font-weight: 600 !important; margin-bottom: .35rem !important; }
  .private-registry-page .private-client-main p { color: var(--ui-muted-foreground) !important; font-size: .75rem !important; font-weight: 400 !important; overflow-wrap: anywhere; }
  .private-registry-page .private-status-chip { font-size: .6875rem !important; font-weight: 500 !important; min-height: 1.5rem !important; padding: .25rem .6rem !important; }
  .private-registry-page .private-row-open { background: var(--ui-background) !important; border-color: var(--ui-border) !important; color: var(--ui-muted-foreground) !important; }
  .private-registry-page .private-client-row:is(:hover, :focus-visible) .private-row-open { background: var(--ui-foreground) !important; border-color: var(--ui-foreground) !important; color: var(--ui-background) !important; }
  .private-registry-page .private-search-status { border-bottom: 1px solid var(--ui-border) !important; border-radius: 0 !important; margin: 0 !important; padding: .75rem 0 !important; }
  @media (max-width: 700px) {
    .private-registry-page .private-client-row { gap: .75rem !important; grid-template-columns: 1.5rem minmax(0, 1fr) 2.5rem !important; position: static !important; }
    .private-registry-page .private-client-state { grid-column: 2 !important; justify-content: flex-start !important; }
    .private-registry-page .private-row-open { grid-column: 3 !important; grid-row: 1 / 3 !important; position: static !important; }
  }
}
@media (max-width: 700px) {
  .private-registry-page { padding: 1.25rem 1rem 2rem; }
  .private-registry-toolbar { align-items: stretch; flex-direction: column; }
  .private-registry-search { width: 100%; }
}

.private-page-surface {
  background: transparent;
}

.private-client-surface {
  margin-top: 0;
  padding-top: 0;
  position: relative;
  z-index: 1;
}

.private-review-head,
.private-search-card,
.private-search-status,
.private-client-list,
.private-client-row,
.private-empty-state,
.private-page-surface :deep(.pagination) {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.private-review-head {
  align-items: flex-end;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
  display: flex;
  gap: 22px;
  justify-content: space-between;
  padding: 24px 26px;
  position: relative;
  z-index: 2;
}

.private-review-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.private-title-block {
  min-width: 0;
  position: relative;
  z-index: 2;
}

.private-title-block h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.private-title-block p {
  color: #607d8b;
  line-height: 1.45;
  margin: 6px 0 0;
  max-width: 720px;
}

.private-add-link {
  align-items: center;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  color: #263238;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.82rem;
  font-weight: 700;
  gap: 8px;
  min-height: 40px;
  padding: 0 13px 0 16px;
  position: relative;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
  z-index: 2;
}

.private-add-link:hover {
  background: #eef7f7;
  border-color: #80cbc4;
  box-shadow: 0 10px 18px -18px rgba(0, 105, 92, 0.55);
  color: #00695c;
}

.private-add-link i {
  color: #00897b;
  font-size: 19px;
}

.private-search-card {
  background: #f5f7f8;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 14px 26px -24px rgba(38, 50, 56, 0.74);
  margin-bottom: 16px;
  padding: 12px 16px;
}

.private-search-card:has(+ .private-search-status) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: none;
  margin-bottom: 0;
}

.private-search-card form,
.private-search-card .input-field {
  margin: 0;
}

.private-search-card .input-field {
  position: relative;
}

.private-search-card input[type="search"] {
  background: #ffffff;
  border: 1px solid #e1e8eb !important;
  border-bottom: none !important;
  border-radius: 6px;
  box-sizing: border-box;
  box-shadow: none !important;
  color: #263238;
  font-weight: 600;
  height: 48px;
  line-height: 48px;
  margin: 0;
  padding-left: 46px;
  padding-right: 42px;
  width: 100%;
}

.private-search-card .label-icon {
  align-items: center;
  display: flex;
  height: 48px;
  left: 10px;
  line-height: 48px;
  position: absolute;
  top: 0;
}

.private-search-card .material-icons {
  color: #00897b;
  height: 48px;
  line-height: 48px;
}

.private-search-card .input-field > i {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 48px;
  line-height: 48px;
  position: absolute;
  right: 10px;
  top: 0;
}

.private-search-status {
  align-items: center;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 16px 28px -24px rgba(38, 50, 56, 0.72);
  color: #263238;
  display: flex;
  justify-content: space-between;
  margin: 0 0 16px;
  padding: 12px 14px 12px 16px;
}

.private-search-status span {
  color: #607d8b;
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.private-search-status strong {
  color: #263238;
  font-size: 0.98rem;
}

.private-search-status button {
  align-items: center;
  background: #f7f7f7;
  border: 1px solid #e1e8eb;
  border-radius: 50%;
  color: #455a64;
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  padding: 0;
  width: 32px;
}

.private-search-status button i {
  font-size: 18px;
}

.private-client-list {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: 0 18px 34px -31px rgba(38, 50, 56, 0.75);
  margin-top: 16px;
  overflow: hidden;
}

.private-client-row {
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #e1e8eb;
  color: #263238;
  display: grid;
  gap: 18px;
  grid-template-columns: 54px minmax(0, 1fr) minmax(150px, auto) 40px;
  min-height: 88px;
  padding: 18px 22px;
  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.private-client-row:last-child {
  border-bottom: 0;
}

.private-client-row:hover {
  background: #f8fafb;
  color: #263238;
  transform: translateY(-1px);
}

.private-client-row.is-pending {
  background: #fffdf8;
}

.private-client-row.is-inactive {
  background: #fafafa;
}

.private-row-number {
  align-items: center;
  background: #f5f7f8;
  border: 1px solid #d7e1e5;
  border-radius: 6px;
  color: #546e7a;
  display: inline-flex;
  font-size: 0.82rem;
  font-weight: 800;
  height: 38px;
  justify-content: center;
  width: 44px;
}

.private-client-main {
  min-width: 0;
}

.private-client-main h6 {
  color: #263238;
  font-size: 1.04rem;
  font-weight: 800;
  line-height: 1.35;
  margin: 0 0 7px;
}

.private-client-main p {
  align-items: center;
  color: #607d8b;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.88rem;
  font-weight: 600;
  gap: 7px;
  margin: 0;
}

.private-contact-dot {
  background: #c4d3d9;
  border-radius: 50%;
  display: inline-flex;
  height: 5px;
  width: 5px;
}

.private-client-state {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.private-status-chip {
  align-items: center;
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1.2;
  min-height: 32px;
  padding: 0 12px;
  white-space: nowrap;
}

.private-status-chip.is-active {
  background: #e6fff5;
  border: 1px solid #5ee0b4;
  color: #008a5b;
}

.private-status-chip.is-inactive {
  background: #ffebee;
  border: 1px solid #ffcdd2;
  color: #b71c1c;
}

.private-status-chip.is-pending {
  background: #fff8e1;
  border: 1px solid #ffe082;
  color: #795548;
}

.private-row-open {
  align-items: center;
  background: #f8fafb;
  border: 1px solid #d7e1e5;
  border-radius: 6px;
  color: #263238;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  justify-self: end;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
  width: 36px;
}

.private-client-row:hover .private-row-open {
  background: #e0f2f1;
  border-color: #80cbc4;
  color: #00695c;
}

.private-row-open i {
  font-size: 18px;
}

.private-empty-state {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: 0 18px 34px -31px rgba(38, 50, 56, 0.75);
  color: #607d8b;
  margin-top: 16px;
  padding: 34px 22px;
}

.private-empty-state h6 {
  color: #263238;
  font-weight: 800;
  margin: 0 0 8px;
}

.private-empty-state p {
  margin: 0;
}

.top-card {
  background-color: #163f53;
}

.top-card-light {
  background-color: #254657;
}

.top-card-dark {
  background-color: #163f53;
}

/* .progress {
  margin-top: -10px;
} */

.custom-nav {
  height: 15px;
}

/* .nav-extended .nav-wrapper {
  padding: 0 20px;
} */

.brand-logo {
  font-weight: 300;
  font-size: 1.5rem;
}

.nav-wrapper ul li a {
  font-weight: 400;
  padding: 0 15px;
}

.nav-content {
  min-height: 20px;
}

@media only screen and (max-width: 992px) {
  .private-review-head {
    align-items: flex-start;
    flex-direction: column;
  }

  .private-client-row {
    align-items: flex-start;
    grid-template-columns: 44px 1fr 36px;
  }

  .private-client-state {
    grid-column: 2 / 4;
    justify-content: flex-start;
  }
}

@media only screen and (min-width: 601px) and (max-width: 992px) {
  .private-client-row {
    grid-template-columns: 44px minmax(0, 1fr) minmax(150px, auto) 40px;
  }

  .private-client-state {
    grid-column: 3;
    justify-content: flex-end;
  }

  .private-row-open {
    align-self: center;
  }
}

@media only screen and (max-width: 600px) {
  .private-review-head {
    gap: 14px;
    padding: 22px;
  }

  .private-title-block p {
    font-size: 0.95rem;
  }

  .private-add-link {
    width: 100%;
    justify-content: center;
  }

  .private-search-card {
    padding: 10px;
  }

  .private-search-status {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .private-search-status button {
    border-radius: 6px;
    width: 100%;
  }

  .private-client-row {
    gap: 12px;
    padding: 16px;
  }

  .private-row-open {
    align-self: center;
    height: 42px;
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .private-review-head,
  .private-search-card,
  .private-search-status,
  .private-client-list,
  .private-client-row,
  .private-empty-state,
  .private-page-surface :deep(.pagination) {
    animation: none;
  }
}
</style>
